import numeral from 'numeral';

export default function formatNumber(number = 0, type = '', decimals, optionalDecimals) {
  const confirmNumber = Number(number);
  if (confirmNumber === Number.NaN) {
    return number;
  }
  if (`${confirmNumber}`.toLowerCase().includes('e')) {
    number = 0;
  }

  const isKBig = confirmNumber >= 1000;
  const isMBig = confirmNumber >= 1000000;
  let formatting = `0.00a`;

  if (!decimals || (decimals !== '0' && decimals !== '00' && decimals !== '000')) {
    // Default section, when no formatting is specified.
    switch (type.toUpperCase()) {
      case 'CURRENCY':
        formatting = isKBig ? '$0.0a' : `$0.00a`;
        break;
      case 'DECIMAL':
        formatting = isKBig ? '0.0a' : `0.00a`;
        break;
      case 'PERCENTAGE':
        number /= 100;
        formatting = '0%';
        break;
      case 'DECIMAL_PERCENTAGE':
        number /= 100;
        formatting = '0.00%';
        break;
      case 'RAW_PERCENTAGE':
        formatting = '0%';
        break;
      case 'FREQUENCY':
        formatting = `0.00a`;
        break;
      case 'RATIO':
        number /= 100;
        formatting = '(0.00)';
        break;
      case 'VISITS':
        if (isMBig) {
          formatting = '0.00a';
        } else {
          formatting = isKBig ? '0.0a' : '0a';
        }
        break;
      default:
        formatting = isKBig ? '0.0a' : `0a`;
        break;
    }
  } else {
    // Need to accommodate user provided decimals.
    const decimalPlaces = optionalDecimals ? `[${decimals}]` : decimals;
    switch (type.toUpperCase()) {
      case 'CURRENCY':
        if (isKBig) {
          formatting = optionalDecimals ? '$0.[0]a' : '$0.0a';
        } else {
          formatting = optionalDecimals ? '$0.[00]a' : '$0.00a';
        }
        break;
      case 'DECIMAL':
        if (isKBig) {
          formatting = optionalDecimals ? '0.[0]a' : '0.0a';
        } else {
          formatting = optionalDecimals ? '0.[00]a' : '0.00a';
        }
        break;
      case 'PERCENTAGE':
      case 'DECIMAL_PERCENTAGE':
        number /= 100;
        formatting = `0.${decimalPlaces}%`;
        break;
      case 'RAW_PERCENTAGE':
        formatting = `0.${decimalPlaces}%`;
        break;
      case 'FREQUENCY':
        formatting = `0.${decimalPlaces}a`;
        break;
      case 'VISITS':
        if (isMBig) {
          formatting = optionalDecimals ? '0.[00]a' : '0.00a';
        } else if (isKBig) {
          formatting = optionalDecimals ? '0.[0]a' : '0.0a';
        } else {
          formatting = '0a';
        }
        break;
      default:
        if (isKBig) {
          formatting = optionalDecimals ? '0.[0]a' : '0.0a';
        } else {
          formatting = '0a';
        }
        break;
      case 'RATIO':
        number /= 100;
        formatting = '(0.00)';
        break;
    }
  }

  const num = numeral(number);
  return type.toUpperCase() === 'RATIO' ? `${num.format(formatting)}:1` : num.format(formatting);
}

export function formatNumberAsFullNumber(number = 0, type = '', decimals, optionalDecimals = true) {
  const confirmNumber = Number(number);
  if (confirmNumber === Number.NaN) {
    return number;
  }
  if (`${confirmNumber}`.toLowerCase().includes('e')) {
    number = 0;
  }

  let formatting = '0,0.[00]';

  if (!decimals || (decimals !== '0' && decimals !== '00')) {
    // Default section, when no formatting is specified.
    switch (type.toUpperCase()) {
      case 'CURRENCY':
        formatting = '$0,0.[00]';
        break;
      case 'DECIMAL':
        formatting = '0,0.[00]';
        break;
      case 'PERCENTAGE':
        number /= 100;
        formatting = '0.[00]%';
        break;
      case 'DECIMAL_PERCENTAGE':
        number /= 100;
        formatting = '0.00%';
        break;
      case 'RAW_PERCENTAGE':
        formatting = '0.[00]%';
        break;
      case 'FREQUENCY':
        formatting = '0.[00]';
        break;
      case 'VISITS':
        formatting = '0,0.[00]';
        break;
      case 'RATIO':
        number /= 100;
        formatting = '0,0.[0000]';
        break;
      default:
        formatting = '0,0.[00]';
        break;
    }
  } else {
    // Need to accommodate user provided decimals.
    const decimalPlaces = optionalDecimals ? `[${decimals}]` : decimals;
    switch (type.toUpperCase()) {
      case 'CURRENCY':
        formatting = `$0,0.${decimalPlaces}`;
        break;
      case 'DECIMAL':
        formatting = `0,0.${decimalPlaces}`;
        break;
      case 'PERCENTAGE':
      case 'DECIMAL_PERCENTAGE':
        number /= 100;
        formatting = `0.${decimalPlaces}%`;
        break;
      case 'RAW_PERCENTAGE':
        formatting = `0.${decimalPlaces}%`;
        break;
      case 'RATIO':
        number /= 100;
        formatting = '0,0.[0000]';
        break;
      case 'FREQUENCY':
      case 'VISITS':
      default:
        formatting = `0,0.${decimalPlaces}`;
        break;
    }
  }

  const num = numeral(number);
  return type.toUpperCase() === 'RATIO' ? `${num.format(formatting)}:1` : num.format(formatting);
}

export function formattedNumberValue(number = '0') {
  const isPercentageValue = number && number.endsWith('%');
  const num = numeral(isPercentageValue ? number.replace('%', '') : number);
  return num.value();
}
